import { Section, Title } from '../../components/Common/PageElement';
import React from "react";
import "./index.css"
import {useState} from "react";
import {Container} from "react-bootstrap";
import image1 from "./FAQimages/AnnoviewFAQ1.png";
import axios from "axios";
import {CSV_EXPORT, EMAIL_SERVICE_ID, EMAIL_TEMPLATE_ID_2, EMAIL_USER_ID, SERVER_URL} from "../../services/Config";

import emailjs from "emailjs-com";
// import {
//     DISABLED_COLOR,
//     PRIMARY_COLOR,
// } from "../../components/Common/StyleElement";

const linkColor = '#1E66E5'

const handleDownloadCSV = () =>{
    const formData = new FormData();

    // slr4 example
    let token = 'example_5'
    formData.append("token", token);
    axios
        .post(SERVER_URL + CSV_EXPORT, formData)
        .then(response=>{
            // console.log(response.data)

            var myblob = new Blob([response.data], {
                type: 'text/plain'
            });
            const filename = "annoviewTemplate.csv"
            const url = URL.createObjectURL(myblob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
            // saveBlob(myblob, 'annoview.csv');
        })
}


const data = [
    ["Column explanation", ".csv downloaded from Search GTDB", ".csv downloaded from uploading NCBI .gbk/.gff", "Columns required for upload"],
    // ["Genome/assembly accession", "GTDB ID", "-", "Yes and must be the first column"],
    ["Genome/assembly/nucleotide accession", "GTDB ID", "Nucleotide ID", "Yes and must be the first column"],
    ["Organism name", "Species", "Organism", "Yes and needs to be the second column"],
    ["Taxonomy level", "Domain", "-", "Optional"],
    ["Taxonomy level", "Phylum", "-", "Optional"],
    ["Taxonomy level", "Class", "-", "Optional"],
    ["Taxonomy level", "Order", "-", "Optional"],
    ["Taxonomy level", "Family", "-", "Optional"],
    ["Taxonomy level", "Genus", "-", "Optional"],
    ["Gene product", "-", "Product", "Optional"],
    ["Protein ID", "GTDB Gene ID", "Protein ID", "Yes"],
    ["Gene name", "-", "Gene", "Optional"],
    ["Start location", "Start", "Start", "Yes"],
    ["Stop location", "End", "End", "Yes"],
    ["Orientation", "Strand", "Strand", "Optional"],
    ["Nucleotide sequence length", "CDS Length", "CDS Length", "Yes"],
    ["KEGG orthology", "KEGG", "-", "Optional"],
    ["Pfam protein family", "Pfam", "-", "Optional"],
    ["TIGRFAM protein family", "TIGRFAM", "-", "Optional"],
    ["Center gene used for gene neighborhood clustering", "Default Center", "-", "Optional"],
    ["Protein sequence", "Sequence", "Sequence", "Optional"],
    ["Customized protein annotation by user", "-", "-", "Optional"]
];


const SearchFaqs = [
    {
        question: "What format should my sequence be?",
        answer:
        <div>
            <p className="faq-answer" style={{fontSize:'16px'}}>
                Your sequence must be a protein (amino acid) sequence in FASTA format with the header or without. e.g.,
            </p>
            <p className="faq-answer" style={{fontSize:'12px'}}>
                >tr|Q9FAE8|Q9FAE8_9BURK Flagellin OS=Acidovorax avenae subsp. avenae OX=80870 GN=N1141-fla1 PE=3 SV=1 <br />
                MASTINTNVSSLTAQRNLSLSQSSLNTSIQRLSSGLRINSAKDDAAGLAISERFTSQIRG<br />
                LNQAVRNANDGISLAQTAEGALKSTGDILQRVRELAVQSANATNSSGDRKAIQAEVGQLL<br />
                SEMDRIAGNTEFNGQKLLDGSFGSATFQVGANANQTITATTGNFRTNNYGAQLTASATGA<br />
                ATTGATAGSAGAAAGTVVIAGLQTKTVNVAAAGTASDIASAVNAVADSTGVTASARNVSE<br />
                MKFSGTGSFTLAVKGDNSTAANVTFNVSATSTAAGLAEAVKAFNDVSSQTGVTAKLNSDS<br />
                SGLILTNESGNDINIANGSSSAAGITLASQDAVTTQSSGTLTFTSATAAGTGVTVASRGT<br />
                VEYKSDKGYTVSGTGGTMTNATATSSTLTKVSDIDVSTVDGSTKALKIIDAALSAVNGQR<br />
                ASFGALQSRFETTVNNLQSTSENMSASRSRIQDADFAAETANLSRSQILQQAGTAMVAQANQLPQGVLSLLK</p>
        </div>

    },
    {
        question: "Which methods/databases are used when I use the Search GTDB option?",
        answer:

            <p className="faq-answer" style={{fontSize:'16px'}}>
                The search is using DIAMOND default mode to perform a protein sequence similarity search against the AnnoView database,
                which is based on the
                <a href={'https://gtdb.ecogenomic.org/stats/r95'} rel="noopener noreferrer" target="_blank" style={{ color: linkColor,textDecoration: 'underline'}}> GTDB data (Release 95) </a>
                and
                <a href={'http://annotree.uwaterloo.ca'} rel="noopener noreferrer" target="_blank" style={{ color: linkColor,textDecoration: 'underline'}}> AnnoTree database </a>
                The protein homology search criteria includes E-value, coverage cut-off, and which database to search (bacteria/archaea).
                Annotations are from the AnnoTree database, with every protein sequence annotated by KEGG orthology identifiers,
                Pfam protein families and TIGRFAM protein families.

            </p>


    },
    {
        question: "What if I want to search against a different database?",
        answer:
            <p className="faq-answer" style={{fontSize:'16px'}}>
                This is not currently supported. Future versions of AnnoView will be updated to the latest
                <a href={'https://gtdb.ecogenomic.org'} rel="noopener noreferrer" target="_blank" style={{ color: linkColor,textDecoration: 'underline'}}> GTDB </a>
                release.
            </p>
    },
    {
        question: "Can I search multiple protein sequences using Search GTDB?",
        answer:
            <p className="faq-answer" style={{fontSize:'16px'}}>
                No. Only one protein sequence is allowed at a time.
            </p>
    },
    // {
    //     question: "There is only one hit on the Intermediate page.",
    //     answer:
    //         <p className="faq-answer" style={{fontSize:'16px'}}>
    //             This is because there is no protein sequence in the AnnoView database that matches the query.
    //             Try to modify the search criteria, or search in the other database (bacteria/archaea).
    //         </p>
    // },
    {
        question: "Will I still be able to see the result page if I lose internet connection before the search is done?",
        answer:
            <p className="faq-answer" style={{fontSize:'16px'}}>
                No, you won’t be able to see the result even if the internet is reconnected.
                You’ll have to perform the search again with your query.
            </p>
    },
    {
        question: "Is there a way to save the result of the Intermediate page?",
        answer:
            <p className="faq-answer" style={{fontSize:'16px'}}>
                No. The search result can only be saved after the gene neighborhood is displayed.
                This is something that will be developed for later versions of the tool.
            </p>
    },
    {
        question: "How long is it going to take for a query using the Search GTDB option? ",
        answer:
            <p className="faq-answer" style={{fontSize:'16px'}}>
                Running a query against the archaea database typically takes around 15 seconds,
                while a query against the bacteria database typically takes about 6 minutes.
                These times may increase depending on the number of concurrent users.
            </p>
    },
    {
        question: "What if there are multiple protein hits similar to the query in one genome? Will this tool show all of them? ",
        answer:
            <p className="faq-answer" style={{fontSize:'16px'}}>
                Yes, our tool provides the flexibility to display multiple protein hits if they are found within a single genome.
                After entering your query, you will be directed to an intermediate page where you can choose which protein hits and
                their associated gene neighborhoods you would like to view. If there are multiple hits within one genome,
                you have the option to display either a single hit or select multiple hits for further exploration.
                This allows you to customize your results based on your specific interests or research requirements.
            </p>
    },


];


const UploadFaqs = [
    {
        question: "What format should my data be when uploading to AnnoView?",
        answer:
            <p className="faq-answer" style={{fontSize:'16px'}}>
                Annoview currently accepts .gbk, .gff and .csv format files.
            </p>
    },
    {
        question: "What kind of information should I include if I upload .csv format files to AnnoView?",
        answer:
            <p className="faq-answer" style={{fontSize:'16px'}}>
                The .csv file should include the following columns: GTDB/nucleotide ID (must in the first column),
                organism/species name (must in the second column), GTDB gene ID/ Protein ID, start position, end position,
                CDS length, and at least one column with metadata to annotate the genes with
                (gene name, product, KEGG, Pfam, TIGRFAM etc).
                The following columns are optional: sequence, domain, phylum, class, order, family, genus, default center
                (to set a gene to center the rows around), extra metadata/function annotation columns.
                Download a template here <a href="#" onClick={handleDownloadCSV} style={{ color: linkColor,textDecoration: 'underline'}}>Slr4_example</a>.
            </p>
    },
    {
        question: "What is the file size limit for upload to AnnoView?",
        answer:
            <p className="faq-answer" style={{fontSize:'16px'}}>
                Currently, the maximum size for a single file upload is 5MB.
                and the maximum total file size for multiple files is 16 MB.
            </p>
    },
    {
        question: "Can I upload multiple .csv files to AnnoView?",
        answer:
            <p className="faq-answer" style={{fontSize:'16px'}}>
                Only one .csv file can be uploaded at a time.
            </p>
    },

    {
        question: "What does each column mean in the .csv file downloaded from Search GTDB? Is there a difference" +
            " between the .csv files downloaded from AnnoTree and from uploading?",
        answer:
            <div>
                <br/>
                <table className="myTable">
                    <tbody>
                    {data.map((row, i) => (
                        <tr key={i} className={i === 0 ? "headerRow" : ""}>
                            {row.map((cell, j) => (
                                <td key={j} className="myCell">
                                    <p style={{fontSize:'13px'}}>
                                        {cell}
                                    </p>

                                </td>
                            ))}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

    },
]

const VisualizationFaqs = [
    {
        question: "How can I save my visualizations for editing later?",
        answer:
            <p className="faq-answer" style={{fontSize:'16px'}}>
                You can download the figure in .svg format, and edit it using a vector graphic editor such as
                Adobe Illustrator or Inkscape. An alternative way of saving or editing the visualization is to
                download the gene neighborhood dataset in .csv format. You can then add columns that contain
                taxonomic information, default centering instructions for the visualization, or protein annotations to
                the table. This table in .csv format can be re-uploaded to AnnoView.
            </p>
    },
    {
        question: "Is there a way to reorder and align the gene neighborhoods?\n",
        answer:
            <p className="faq-answer" style={{fontSize:'16px'}}>
                Yes. Gene neighborhoods can be sorted and aligned based on a clustering algorithm implemented in our server.
                You can do this by picking a center gene first, and then right clicking on the gene and choosing “center on that gene.
                This centers the rows on the first gene with a matching annotation (whichever annotations are currently being visualized) in each row.
                Alternatively, you can download the .csv file and change the default center gene to whichever gene you want (one in each row).
                You can also manipulate row order manually by dragging the gene neighborhood labels on the left side.
                Each row can also be moved right-left by grabbing the row so that it can be aligned by the user.
                Rows can also be flipped by right clicking on a row and choosing "Flip track"."
            </p>
    },
    {
        question: "Can I delete unwanted gene neighborhood tracks?",
        answer:
            <p className="faq-answer" style={{fontSize:'16px'}}>
                Yes. You can select one or multiple gene neighborhood tracks by clicking on their labels on the left,
                then right click on the labels and choose “Delete all selected tracks”.

            </p>
    },
    {
        question: "Why are some genes are colored light grey?",
        answer:
            <p className="faq-answer" style={{fontSize:'16px'}}>
                These genes don’t have any annotations under the currently selected annotation category.

            </p>
    },
    {
        question: "There are so many genes in the browser. How do I quickly find a specific gene?",
        answer:
            <p className="faq-answer" style={{fontSize:'16px'}}>
                You can use the search function in the toolbar and type the annotation of the gene you want to locate.
                The browser will then highlight all the genes with that specific annotation.
                The genes in the search bar are sorted according to their frequency,
                allowing users to locate the most commonly occurring genes within the current gene neighborhoods.

            </p>
    },
]

const GeneralFaqs = [
    // {
    //     question: "How long will the url link for my AnnoView session be available?",
    //     answer:
    //         <p className="faq-answer" style={{fontSize:'16px'}}>
    //             {/*We have set the default to be X(1 week?).*/}
    //             2 weeks.
    //         </p>
    // },
    // {
    //     question: "Contact information",
    //     answer:
    //         <p className="faq-answer" style={{fontSize:'16px'}}>
    //             We welcome suggestions and feedback. If you have any questions that are not addressed in our FAQ page,
    //             or if you have ideas for how we can improve our tools,
    //             please don't hesitate to reach out to us via email at XXX.
    //         </p>
    // },
    {
        question: "What browser do you recommend to run AnnoView?\n",
        answer:
            <p className="faq-answer" style={{fontSize:'16px'}}>
                Chrome.
            </p>
    },
    {
        question: "Other questions/comments?\n",
        answer:
            <p className="faq-answer" style={{fontSize:'16px'}}>
                {/*Please contact x86wei@uwaterloo.ca or use the following question form.*/}
                Please contact h29tan@uwaterloo.ca or use the following question form.
            </p>
    },

]


const FAQNav = ({question,id,FAQSection})=>{

    let targetId = FAQSection + id

    return (
        <li key={id} style={{listStyleType: 'none'}}>
            <div>
                <a href={`#${targetId}`} style={{ color: linkColor,textDecoration: 'underline',fontSize:'14px'}}>{question}</a>
            </div>
        </li>



    )
}


const FAQItem = ({ question, answer,id, FAQSection}) => {
    const [isOpen, setIsOpen] = useState(true);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="faq-item" id={FAQSection + id}>
            <h4 onClick={toggle} className="faq-question">
                {question}
            </h4>
            {isOpen &&
                <div>
                    {/*<p className="faq-answer" style={{fontSize:'16px'}}>{answer}</p>*/}
                    {/*{payload &&  <img src={image1} alt={question}/>}*/}
                    {/*{payloadText && <p className="faq-answer" style={{fontSize:'12px'}}>{payloadText}</p>}*/}
                    {/*{payloadLink && <a href={payloadLink} rel="noopener noreferrer" target="_blank">a</a>}*/}
                    {answer}
                </div>}
            <hr className={'dotted'}/>
        </div>
    );
};

// const FAQPage = () => {
//     return (
//         <Section id={'FAQ'}>
//             aa
//         </Section>
//
//     )
// }

const FAQPage = () => {

    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");


    const handleSubmit = (e) => {
        e.preventDefault();

        emailjs.init(EMAIL_USER_ID);

        // let feedback = `Name:${username}\n Comments:\n${message}`


        var templateParams = {
            userEmail:email,
            userName:username,
            message:message
        };
        emailjs.send(EMAIL_SERVICE_ID, EMAIL_TEMPLATE_ID_2,templateParams)
            .then((result) => {
                // console.log("success")
                alert('Thank you for your comments!')
                // window.location.href = "/#FAQ";
                // window.location.reload()  //This is if you still want the page to reload (since e.preventDefault() cancelled that behavior)
            }, (error) => {
                console.log(error.text);
            });
        setUsername("");
        setEmail("");
        setMessage("");


    };

    return (
        <Section id={'FAQ'}>
            <Container>

                <div className="FAQNavigation">
                    <h1 style={{ fontWeight: 'bold', textAlign: 'center'}}>Frequently Asked Question</h1>
                    <hr className="solid"/>

                    <div className="faq-container">
                        {/*<h3 style={{textDecoration: 'underline',paddingLeft:"45px" }}>Search GTDB</h3>*/}
                        <h3 style={{paddingLeft:"45px" }}>Search GTDB</h3>
                        <hr className="dashed"/>
                        <ul>
                            {SearchFaqs.map((faq, index) => (
                                <FAQNav FAQSection={'Search'}
                                        question={faq.question}
                                        id={index}
                                />
                            ))}
                        </ul>
                    </div>



                    <div className="faq-container">
                        <h3 style={{paddingLeft:"45px" }}>Upload</h3>
                        <hr className="dashed"/>
                        <ul>
                            {UploadFaqs.map((faq, index) => (
                                <FAQNav FAQSection={'Upload'}
                                        question={faq.question}
                                        id={index}
                                />
                            ))}
                        </ul>

                    </div>


                    <div className="faq-container">
                        <h3 style={{paddingLeft:"45px" }}>Visualization</h3>
                        <hr className="dashed"/>
                        <ul>
                            {VisualizationFaqs.map((faq, index) => (
                                <FAQNav FAQSection={'Visualization'}
                                        question={faq.question}
                                        id={index}
                                />
                            ))}
                        </ul>

                    </div>


                    <div className="faq-container">
                        <h3 style={{paddingLeft:"45px" }}>General Questions</h3>
                        <hr className="dashed"/>
                        <ul>
                            {GeneralFaqs.map((faq, index) => (
                                <FAQNav FAQSection={'General'}
                                        question={faq.question}
                                        id={index}
                                />
                            ))}
                        </ul>

                    </div>

                    <hr className="solid"/>
                </div>

                {/*<div>*/}
                {/*    <hr className="dashed"/>*/}
                {/*    <a href={'#feedback'}>Feedback</a>*/}
                {/*</div>*/}



                {/* ----------------------------------------- divider ------------------------------------------ */}


                <div className="FAQPage">
                    <hr className="solid"/>
                    {/*<h2 style={{ fontWeight: 'bold'}}>Frequently Asked Question</h2>*/}
                    {/*<h3 style={{textDecoration: 'underline' }}>Search GTDB</h3>*/}
                    <div>
                        <h3 style={{paddingLeft:"45px" ,fontWeight: 'bold'}}>Search GTDB</h3>
                        <hr className="dashed"/>
                        <div className="faq-container">
                            {SearchFaqs.map((faq, index) => (
                                <FAQItem id={index}
                                         question={faq.question}
                                         answer={faq.answer}
                                         FAQSection={'Search'}
                                />
                            ))}
                        </div>

                    </div>

                    <div>
                        <h3 style={{paddingLeft:"45px",fontWeight: 'bold' }}>Upload</h3>
                        <hr className="dashed"/>
                        <div className="faq-container">
                            {UploadFaqs.map((faq, index) => (
                                <FAQItem id={index}
                                         question={faq.question}
                                         answer={faq.answer}
                                         FAQSection={'Upload'}
                                />
                            ))}
                        </div>
                    </div>

                    {/*<h3 style={{textDecoration: 'underline' }}>Uploading custom data</h3>*/}


                    <div>
                        <h3 style={{paddingLeft:"45px",fontWeight: 'bold' }}>Visualization</h3>
                        <hr className="dashed"/>
                        <div className="faq-container">
                            {VisualizationFaqs.map((faq, index) => (
                                <FAQItem id={index}
                                         question={faq.question}
                                         answer={faq.answer}
                                         FAQSection={'Visualization'}
                                />
                            ))}
                        </div>
                    </div>


                    <div>
                        <h3 style={{paddingLeft:"45px",fontWeight: 'bold' }}>General Questions</h3>
                        <hr className="dashed"/>
                        <div className="faq-container">
                            {GeneralFaqs.map((faq, index) => (
                                <FAQItem id={index}
                                         question={faq.question}
                                         answer={faq.answer}
                                         FAQSection={'General'}
                                />
                            ))}
                        </div>
                    </div>

                </div>

                {/* ----------------------------------------- divider ------------------------------------------ */}

                <div id={'feedback'} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <h4>Question form</h4>
                    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', width: '1000px', gap: '10px' }}>
                        <input style={{ padding: '10px' ,fontSize:'14px'}} type="text" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Your Name" required />
                        <input style={{ padding: '10px' ,fontSize:'14px'}} type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your Email" required />
                        <textarea style={{ padding: '10px', minHeight: '100px' ,fontSize:'14px'}} value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Your Feedback" required />
                        <button style={{ padding: '10px', backgroundColor: 'lightblue', border: 'none', borderRadius: '5px' }} type="submit">Submit Comments/Question</button>
                    </form>
                </div>
            </Container>

        </Section>

    );
};

export default FAQPage;

